import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { Observer } from "azure-devops-ui/Observer";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { TextField } from "azure-devops-ui/TextField";

export default class ObserverExample extends React.Component {
    private buttonText = new ObservableValue<string>("Observable Value");

    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <TextField
                    ariaLabel="Observable Value"
                    value={this.buttonText}
                    onChange={(e, newValue) => (this.buttonText.value = newValue)}
                />
                <div style={{ marginTop: "8px" }}>
                    <Observer text={this.buttonText}>
                        {({ text }: { text: string }) => <Button text={text} />}
                    </Observer>
                </div>
            </div>
        );
    }
}
